import * as ReactQuery from 'react-query';
import { InferQueryOptions } from 'services';

import { getPatientSummaryAPI } from './api';

export const GET_PATIENT_SUMMARY_KEY = '@referrals/get-patient-summary';

export function useGetPatientSummary(
  referralId = '',
  options?: InferQueryOptions<typeof getPatientSummaryAPI>
) {
  const { data, isLoading, isError, refetch } = ReactQuery.useQuery(
    [GET_PATIENT_SUMMARY_KEY, referralId],
    () => getPatientSummaryAPI(referralId),
    {
      ...options,
      enabled: options?.enabled ?? Boolean(referralId),
    }
  );

  return {
    patientSummary: data,
    isLoading,
    isError,
    refetch,
  };
}
